
import { $, $$, setWithExpiry, getWithExpiry } from '@/utilities/helpers';
import createFuzzySearch from '@nozbe/microfuzz'

/*------------------------------------------------------------------
Topics
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', function () {

    if ($('.js-topics-grid')) {
        if ($('.js-topics-grid')) new Topics($('.js-topics-grid'), $('.js-topics-input'), $$('.js-topic-letter'), $$('.js-topic-category'), $('.js-clear-filters'), $('.js-search-info'));
    }

    if (window.location.href.includes('/topics/')) {


        // Hide all but the first advert on smaller screens
        if (window.innerWidth < 968) {
            if ($('.advertisement--sidebar-2')) $('.advertisement--sidebar-2').remove();
            if ($('.advertisement--sidebar-3')) $('.advertisement--sidebar-3').remove();
        } else {


            let sidebar = $('.sidebar-wrap');
            let sidebar_height = sidebar.offsetHeight;

            if (sidebar_height < 1300) {
                if ($('.advertisement--sidebar-2')) $('.advertisement--sidebar-2').remove();
                if ($('.advertisement--sidebar-3')) $('.advertisement--sidebar-3').remove();
            } else if (sidebar_height < 2000) {
                if ($('.advertisement--sidebar-3')) $('.advertisement--sidebar-3').remove();
            }

            let sidebar_adverts = $$('.advertisement--300x600');

            if (sidebar_adverts.length > 0) {
                let advert_height = sidebar_adverts[0].offsetHeight;
                let margin_top = (sidebar_height - (advert_height * sidebar_adverts.length)) / (sidebar_adverts.length - 1);

                sidebar_adverts.forEach((advert, index) => {
                    if (index > 0) {
                        // Minor offset to avoid a gap at the bottom of the page
                        advert.style.marginTop = `${margin_top / 1.1}px`;
                    }
                });

            }
        }
    }
}, false);


/**
 * 
 *  Topic filtering functionality
 * 
 */
export class Topics {

    /**
     * 
     * Constructor
     * 
     * @param {element} list - The list element to render the suggestions into
     * @param {element} input - The input element to get the user query from
     * @param {element} element - The suggestion box element
     */
    constructor(grid, input, letters, categories, clear_filters, search_info) {

        // Needs and wants
        this.query = '';
        this.topics = undefined;
        this.filtered_topics = [];
        this.selected_letters = [];
        this.selected_categories = [];
        this.grid = grid;
        this.input = input;
        this.letters = letters;
        this.categories = categories;
        this.clear_filters = clear_filters;
        this.search_info = search_info;
        this.maximum_score_to_render = 4;
        this.nominal_html = this.grid.innerHTML;

        // Initialise the suggestion box interactions
        this.init();

    }

    /**
     * 
     * Initialise the suggestion box interactions
     * 
     */
    init() {

        this.fetch();

        // Attach keyboard events to the input field
        this.input.addEventListener('keydown', (event) => {
            // Return false if the enter key is pressed
            if (event.key === 'Enter') {
                event.preventDefault();
                return false;
            }
        });

        // Attach keyboard events to the input field
        this.input.addEventListener('keyup', () => {
            // Set a timeout on the filter section 
            setTimeout(() => this.filter(), 50);
        });

        // Fetch the list of topics on initial focus
        this.input.addEventListener('focus', () => {
            if (!this.topics) this.fetch();
        });

        // Fetch the list of topics on initial focus
        this.clear_filters.addEventListener('click', (event) => {
            event.preventDefault();
            this.clear();
        });

        // Attach click events to the letters
        this.letters.forEach(letter => {
            letter.addEventListener('click', event => {
                event.preventDefault();
                this.toggleLetter(letter);
            });
        });

        // Attach click events to the cateogries
        this.categories.forEach(category => {
            category.addEventListener('click', event => {
                event.preventDefault();
                this.toggleCategory(category);
            });
        });

        // Attach click events to the see all links on the letters
        this.grid.addEventListener('click', event => {
            if (event.target.classList.contains('js-show-all-from-letter')) {
                event.preventDefault();

                $('.footer').style.display = 'none';
                let $letter = document.querySelector(`.topics__wrap__alphabet__item[data-letter="${event.target.dataset.letter}"]`)

                this.toggleLetter($letter, false);


                // Scroll to rendered letter 
                window.scroll({
                    left: 0,
                    top: document.querySelector(`.topics__wrap__grid__column[data-letter="${event.target.dataset.letter}"]`).getBoundingClientRect().top + window.pageYOffset - 120
                });

                setTimeout(() => $('.footer').style.display = 'block', 1020);


            }
        });

        // Preselect the filters
        this.getFiltersFromURL();

    }

    clear() {
        this.query = '';
        this.input.value = '';
        this.selected_letters = [];
        this.selected_categories = [];
        this.categories.forEach(category => category.classList.remove('active'));
        this.letters.forEach(letter => letter.classList.remove('active'));

        // Show/hide the clear filters button bsed on search parameters being present
        this.clear_filters.classList[this.query.length || this.selected_letters.length > 0 || this.selected_categories.length > 0 ? 'add' : 'remove']('active');

        // Update the search info box
        this.search_info.innerHTML = (this.query.length || this.selected_letters.length > 0 || this.selected_categories.length > 0) ? `Showing ${this.filtered_topics.length} of ${this.topics.length} topics` : '';

        // Show/hide the search info box based on search parameters being present
        this.search_info.classList[this.query.length || this.selected_letters.length > 0 || this.selected_categories.length > 0 ? 'add' : 'remove']('active');

        // Set a timeout on the filter section 
        setTimeout(() => this.grid.innerHTML = this.nominal_html, 50);

    }



    getFiltersFromURL() {

        // Get the URL params
        let url_filters = new URLSearchParams(window.location.search);

        // Set the individual filters and search functions
        for (const [key, value] of url_filters.entries()) {
            if (key === 'category') {

                // Toggle all of our categories
                this.toggleCategory(document.querySelector(`[data-category="${value}"]`));

                // If the category is not visible then add a class to the body
                if (!document.querySelector(`[data-category="${value}"]`).checkVisibility()) {
                    document.body.classList.add('all-categories-visible');
                }
            }

        }

        // Smopoth scroll to the top of the topics div
        if (url_filters.has('keywords')) {
            // Scroll down to the map element on select action
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: document.querySelector('.topics').offsetTop - 120
            });

            // Filter the items 
            this.filter();
        } else if (url_filters.has('category')) {

            for (const [key, value] of url_filters.entries()) {
                if (key === 'category') {
                    // Scroll down to the map element on select action

                    console.log(document.querySelector(`[data-category="${value}"]`))

                    window.scroll({
                        behavior: 'smooth',
                        left: 0,
                        top: document.querySelector(`[data-category="${value}"]`).offsetTop + (window.innerHeight / 2)
                    });

                    // Filter the items 
                    this.filter();

                }

            }
        }



    }

    /**
     * 
     * Toggle categories on and off
     * 
     * @param {node} cateogry 
     */
    toggleCategory(cateogry) {

        if (cateogry.classList.contains('active')) {
            cateogry.classList.remove('active');
            this.selected_categories = this.selected_categories.filter(item => item !== cateogry.dataset.category);
        } else {
            cateogry.classList.add('active');
            this.selected_categories.push(cateogry.dataset.category);
        }

        // Set a timeout on the filter section 
        setTimeout(() => this.filter(), 50);
    }


    /**
    * 
    * Toggle letters on and off
    * 
    * @param {node} letter 
    */
    toggleLetter(letter, scroll_to_letter = false) {

        if (letter.classList.contains('active')) {
            letter.classList.remove('active');
            this.selected_letters = this.selected_letters.filter(item => item !== letter.dataset.letter);
        } else {
            letter.classList.add('active');
            this.selected_letters.push(letter.dataset.letter);
        }

        // Set a timeout on the filter section 
        setTimeout(() => this.filter(), 0);

        if (scroll_to_letter) {

            setTimeout(() => {

                // Scroll to rendered letter 
                window.scroll({
                    behavior: 'smooth',
                    left: 0,
                    top: document.querySelector(`.topics__wrap__grid__column[data-letter="${letter.dataset.letter}"]`).getBoundingClientRect().top + window.pageYOffset - 120
                });

            }, 400);
        } else {
            setTimeout(() => {
                // Scroll to rendered letter 
                window.scroll({
                    left: 0,
                    top: document.querySelector(`.js-topics-grid`).getBoundingClientRect().top + window.pageYOffset - 120
                });
            }, 60);
        }

    }

    /**
     * 
     * Remove any malformed topics 
     * 
     * @param {collection} topics 
     * @returns {collection} topics
     */
    clean_topics(topics) {

        // Remove any null items
        topics = topics.filter(topic => topic.b !== null && topic.b !== undefined);

        // Remove any items where the first character is not a letter
        topics = topics.filter(topic => {
            return topic.b.charAt(0).match(/[a-z]/i)
        });

        //Change all titles to have an upper case first letter
        topics = topics.map(topic => {
            topic.b = topic.b.charAt(0).toUpperCase() + topic.b.slice(1);
            return topic;
        });

        // Retuerned the cleaned up topics
        return topics;
    }


    /**
     * 
     *  Fetch a list of predefined search terms from a JSON file topics
     * 
     */
    fetch() {


        if (getWithExpiry('dermnet_topics')) {

            console.log(`%c dermnet_topics are being reused`, 'color: #A6E3A1');

            // Parse the JSON data
            this.topics = JSON.parse(getWithExpiry('dermnet_topics'));

            // Clean the topics an dremove any null items
            this.topics = this.clean_topics(this.topics);

            // Create a search function
            this.search = createFuzzySearch(this.topics, { key: 'b' });

        } else {
            // Fetch a pre cached JSON file from our CDN
            fetch('/assets/___cache/topics.json?v=1.0.1')
                .then((response) => response.text())
                .then(data => {

                    // Remove the old cache
                    localStorage.removeItem('dermnet_topics');

                    // Cache the data for 1 day
                    setWithExpiry('dermnet_topics', data);

                    // Parse the JSON data
                    this.topics = JSON.parse(data);

                    // Clean the topics an dremove any null items
                    this.topics = this.clean_topics(this.topics);

                    // Create a search function
                    this.search = createFuzzySearch(this.topics, { key: 'b' });

                });
        }
    }


    /**
     * 
     * Filter a list of predefined search terms based on user input
     * 
     */
    filter() {

        if (this.input.value.trim() === '' && this.selected_letters.length === 0 && this.selected_categories.length === 0) {

            // Set a timeout on the filter section 
            this.clear();

            // Return if we have no search queries
            return;
        }

        // Reset the filtered topics
        this.filtered_topics = [];

        // Update the query to match what a user has typed
        this.query = this.input.value.trim();

        // Filter the list of topics based on the query
        if (this.query.length) {
            this.filtered_topics = this.search(this.query);
        }
        // If there is no query then we need to reset the filtered topics
        else {
            this.filtered_topics = this.topics.map(topic => { return { item: topic, score: 0 } })
        }

        // Filter the list of topics based on the selected letters intersecting with the first letter of the topic
        if (this.selected_letters.length > 0) {
            this.filtered_topics = this.filtered_topics.filter(item => this.selected_letters.includes(item.item.b.charAt(0)));
        }

        // Filter the list of topics based on the intersection of two arrays
        if (this.selected_categories.length > 0) {
            this.filtered_topics = this.filtered_topics.filter(item => item.item.e.some(category => this.selected_categories.includes(category)));
        }

        // Remove any items that have a score above the maximum score to render
        this.filtered_topics = this.filtered_topics.filter(item => item.score < this.maximum_score_to_render)

        // Show/hide the clear filters button bsed on search parameters being present
        this.clear_filters.classList[this.query.length || this.selected_letters.length > 0 || this.selected_categories.length > 0 ? 'add' : 'remove']('active');

        // Update the search info box
        this.search_info.innerHTML = (this.query.length || this.selected_letters.length > 0 || this.selected_categories.length > 0) ? `Showing ${this.filtered_topics.length} of ${this.topics.length} topics` : '';

        // Show/hide the search info box based on search parameters being present
        this.search_info.classList[this.query.length || this.selected_letters.length > 0 || this.selected_categories.length > 0 ? 'add' : 'remove']('active');

        // Render the list of suggestions
        this.render();

    }

    /**
     * 
     * Render out a specific letter to a column
     * 
     * @param {string} letter 
     */
    renderLetter(letter) {

        // Reset the filtered topics
        this.filtered_topics = [];

        // Clean the topics an dremove any null items
        this.filtered_topics = this.clean_topics(this.topics);

        // Get the column
        let $column = document.querySelector(`.topics__wrap__grid__column[data-letter="${letter}"]`);

        // Filter out the topics that do not match the selected letter
        this.filtered_topics = this.filtered_topics.filter(item => item.b.charAt(0) === letter);

        // Declare out HTML template
        let html = '<div class="topics__wrap__grid__column__list topics__wrap__grid__column__list--expanded">';

        // Render the list of suggestions
        this.filtered_topics = this.filtered_topics.forEach(item => html += this.item(item.link, item.b));

        // Close the list
        html += '</div>';

        // Append the HTML to the grid
        $column.innerHTML += html;

        // Add the expanded class to the column
        $column.classList.add('expanded');

    }

    /**
     * 
     * Render out the list of suggestions
     * 
     * @param {string} html - HTML template initialiser
     */
    render(html = '') {

        // Clear the currently rendered letters array
        this.currently_rendered_letters = [];

        // Clear the grouped topics
        this.grouped_topics = {};


        // Group the topics by their first letter in an array of arrays instead an object of arrays
        this.grouped_topics = this.filtered_topics.reduce((r, a) => {
            if (isNaN(a.item.b.charAt(0))) {
                r[a.item.b.charAt(0)] = [...r[a.item.b.charAt(0)] || [], a];
            } else {
                r['#'] = [...r['#'] || [], a];
            }

            return r;
        }, {});


        // order the grouped topics by their first letter
        this.grouped_topics = Object.keys(this.grouped_topics).sort().reduce(
            (obj, key) => {
                obj[key] = this.grouped_topics[key];
                return obj;
            },
            {}
        );


        // Empty out the grid
        this.grid.innerHTML = '';

        // If there are no topics then render the empty template
        if (this.filtered_topics.length === 0) this.grid.innerHTML = this.emptyTemplate();

        // Attach a scroll event to the container to render more letters
        const container = document.querySelector('.container');

        if (container) {
            container.addEventListener('scroll', () => {
                const scrollPosition = container.scrollTop + container.clientHeight;
                const gridBottom = this.grid.offsetTop + this.grid.offsetHeight;

                // Check if user is near the bottom of the grid (within 300px)
                if (scrollPosition >= gridBottom - 300) {
                    this.renderMoreLetters();
                }
            });
        }

        // Render the first set of letters
        this.renderMoreLetters();

    }

    /**
     * 
     * Render out the results on a per letter basis
     * 
     */
    renderMoreLetters() {
        console.log(`%c Rendering more letters`, 'color: #A6E3A1');

        // Declare out HTML template
        let html = '';

        // Reset the count
        let count = 0;

        // Loop through the grouped topics and render them out
        for (const [letter, items] of Object.entries(this.grouped_topics)) {
            if (letter && count < 1) {
                // If the letter is not in the currently rendered letters array then render it
                if (!this.currently_rendered_letters.includes(letter)) {

                    // Render the letter results out
                    html += this.template(letter, items);

                    // Increment the count
                    count++;

                    // Add the letter to the currently rendered letters array
                    this.currently_rendered_letters.push(letter);
                }
            }
        }

        // Append the HTML to the grid
        this.grid.innerHTML += html;

        // If we have only rendered 20 letters then we need to render more so it doesnt look like we only have a single letters worth of results
        if (this.grid.querySelectorAll('.topics__wrap__grid__column__list a').length < 100) {
            if (this.filtered_topics.length > this.grid.querySelectorAll('.topics__wrap__grid__column__list a').length) {
                this.renderMoreLetters();
            }
        }

    }

    /**
     * 
     * Mark a searched term in the list of topics
     * 
     * @param {string} name 
     * @returns {string} template 
     */
    marked(name) {
        let regex = new RegExp(this.query.split(' ').map(word => `(${word})`).join('|'), 'gi');
        return name.replace(regex, `<span class="marked">$&</span>`);
    }

    /**
     * 
     * Return a single topic item template
     * 
     * @param {object} item 
     * @returns 
     */
    item(link, title) {
        return /*html*/`
        <a href="${link}">${this.marked(title)}</a>`;
    }


    /**
     * 
     * No results template
     * 
     * @returns {string} template
     */
    emptyTemplate() {
        return /*html*/`
        <div class="topics__wrap__grid__column topics__wrap__grid__column--full">
            <div class="topics__wrap__grid__column__heading">
                <h3 class="h2">No results found</h3>
                <hr>
            </div>
        </div>`;
    }

    /**
     * 
     * Single item template
     * 
     * @param {*} letter 
     * @param {*} items 
     * @param {*} html 
     * @returns 
     */
    template(letter, items) {
        // Return an empty string if our items are all above the maximum score
        if (!items.some(item => item.score < this.maximum_score_to_render)) return ``;

        if (items) {
            items = items.sort((a, b) => a.item.b.localeCompare(b.item.b));
        }

        return /*html*/`
        <div class="topics__wrap__grid__column topics__wrap__grid__column--full" data-letter="${letter}">
            <div class="topics__wrap__grid__column__heading">
                <h3 class="h2">${letter.toUpperCase()}</h3>
                <hr>
            </div>
            <div class="topics__wrap__grid__column__list">
                ${items.map(item => (item.score < this.maximum_score_to_render) ? this.item(item.item.d, item.item.b) : null).join('')}
            </div>
        </div>`;
    }

}